export class DoctorVisitSaveModel {
    Id: number;
    Date: string;
    Coordinator: string;
    Assistant: string;
    Comments: string;
    DoctorId: number;

    constructor() {
        this.Id = 0;
    }
}

export class DoctorVisitDetails {
    id: number;
    medicoId: number;
    mes: number;
    anyo: number;
    coordinador: string;
    realizada: string;
    asistentes: string;
    comentarios: string;
}


